<template>
  <div id="app">
    <template v-if="standaloneRoute">
      <!-- 独立页面（如微信公众号跳转详情）：不渲染全局头部/底部，也不套 wrapper 结构 -->
      <router-view/>
    </template>
    <template v-else>
      <div class="wrapper">
        <Head v-if="showHead"></Head>
        <router-view/>
      </div>
      <Footer></Footer>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'App',
    computed: {
      routeName () {
        return this.$route.name
      },
      // 路由 meta.standalone 为 true 的页面为独立页面
      standaloneRoute () {
        return !!(this.$route.meta && this.$route.meta.standalone)
      },
      // 无头部页面（视频页、操作手册等）
      showHead () {
        return this.routeName !== 'cgspVideo' && this.routeName !== 'cgspVideoDetail' && this.routeName !== 'registerManual'
      }
    }
  }
</script>

<style>
  #app {
    width: 100%;
    height: auto;
  }
  .txtFLASH {
    /*font-size: 20px;*/
    color: red;
    /*margin: 10px;*/
    animation: changeshadow 1s ease-in infinite;
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: changeshadow 1s linear infinite;
    -moz-animation: changeshadow 1s linear infinite;
    -ms-animation: changeshadow 1s linear infinite;
    -o-animation: changeshadow 1s linear infinite;
  }

  @keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  /* 添加兼容性前缀 */
  @-webkit-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  @-moz-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  @-ms-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }

  @-o-keyframes changeshadow {
    0% {
      text-shadow: 0 0 4px red
    }
    50% {
      text-shadow: 0 0 40px red
    }
    100% {
      text-shadow: 0 0 4px red
    }
  }
</style>

<style  scoped>
  .wrapper {
    min-height: calc(100vh - 110px);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue